import React from 'react';
import { YAxis, XAxis } from 'recharts';
import formatData from '../../methods/formatData';

const AxisY = ({
  seriesConfig,
  isOnRight,
  t,
  isVertical,
} = {}) => {
  const position = isOnRight ? 'right' : 'left';
  const cfg = seriesConfig.find(serie => (serie.axisY === position));

  if (!cfg) return null;

  return isVertical ? (
    <XAxis
      xAxisId={position}
      axisLine={false}
      fontSize="10px"
      stroke="#131313"
      tickLine={false}
      tickMargin={7}
      unit={cfg.unit}
      tickFormatter={tick => formatData(tick, false, false, true, t)}
      orientation={position === 'left' ? 'bottom' : 'top'}
      type="number"
    />
  ) : (
    <YAxis
      yAxisId={position}
      axisLine={false}
      fontSize="10px"
      stroke="#131313"
      tickLine={false}
      unit={cfg.unit}
      tickFormatter={tick => formatData(tick, false, false, true, t)}
      orientation={position}
    />
  );
};

export default AxisY;
